import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { Highlight } from "./Highlight";
interface QuoteSuccessProps {
  reference: string;
  email: string;
  onRestart: () => void;
}
export function QuoteSuccess({
  reference,
  email,
  onRestart
}: QuoteSuccessProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="mx-auto max-w-3xl py-10 md:py-20" data-id="element-114" data-mp="14c0wrzz6vh22">
      <h1 className="text-5xl font-bold leading-[1.1] tracking-tight md:text-7xl" data-id="element-115" data-mp="ugpfb9webvqm">
        Demande <Highlight data-id="element-116" data-mp="ggxv2rfadj46">envoyée</Highlight>, merci&nbsp;!
      </h1>
      <p className="mt-6 max-w-xl text-lg text-muted" data-id="element-117" data-mp="ldy0d04bahu8">
        Un chef de projet Affective revient vers vous sous 24 h ouvrées avec un devis détaillé et un BAT. Une copie de votre
        configuration a été envoyée à <span className="font-bold text-ink" data-id="element-118" data-mp="2fsqxx4or9iot">{email}</span>.
      </p>
      <dl className="mt-10 flex border-y border-line py-5" data-id="element-119" data-mp="2fchz6qu86lnc">
        <dt className="text-sm text-muted" data-id="element-120" data-mp="2faykh4o7wino">Référence de la demande</dt>
        <dd className="ml-auto text-sm font-bold tabular-nums" data-id="element-121" data-mp="2bbpnlqxvs4nw">{reference}</dd>
      </dl>
      <button type="button" onClick={onRestart} className="mt-10 inline-flex items-center gap-2 bg-ink px-8 py-4 text-sm font-bold text-paper transition-colors duration-150 ease-out hover:bg-cherry" data-id="element-122" data-mp="2p2uloolloow4">
        Configurer un autre objet
        <ArrowRightIcon size={16} aria-hidden="true" data-id="element-123" data-mp="1wfgruzd789g8" />
      </button>
    </motion.section>;
}